import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Empty, Tag } from "antd";
import { useNavigate } from "react-router";
import "../../../styles/global-ui.css";
import bin_img from "../../../assets/dashboard/bin_img.png";

const normalize = (val) => String(val || "").trim().toLowerCase();

const getPcs = (bin) =>
  Number(bin?.total_quantity || bin?.qty || bin?.quantity || 0);

const Dashboard = ({ washingBins = [], transitBins = [] }) => {
  const [binData, setBinData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const filtered = washingBins.filter((bin) =>
      normalize(bin?.bin_location).includes("washing")
    );

    setBinData(filtered);
  }, [washingBins]);

  const totalBins = binData.length;

  const totalPcs = useMemo(() => {
    return binData.reduce((sum, bin) => sum + getPcs(bin), 0);
  }, [binData]);

  const handleClick = (bin) => {
    navigate(`/view/bin?binId=${encodeURIComponent(bin.bin_id)}`);
  };

  return (
    <div>
      {/* STATS */}
      <div className="compact-stats" style={{ marginBottom: 24 }}>
        <Row gutter={[16, 8]} justify="center">
          <Col xs={24} sm={12}>
            <div className="compact-stat-item">
              <div className="compact-stat-value">{totalBins}</div>
              <div className="compact-stat-label">Washing Bins</div>
            </div>
          </Col>

          <Col xs={24} sm={12}>
            <div className="compact-stat-item">
              <div className="compact-stat-value">{totalPcs}</div>
              <div className="compact-stat-label">Washing Pieces</div>
            </div>
          </Col>
        </Row>
      </div>

      {/* GRID */}
      {binData.length > 0 ? (
        <Row gutter={[16, 16]} className="dashboard-card-grid">
          {binData.map((bin) => (
            <Col xs={24} sm={12} md={8} lg={6} xl={5} key={bin.bin_id}>
              <div className="bin-card" onClick={() => handleClick(bin)}>
                <div className="bin-card-top">
                  <Tag
                    className="location-badge"
                    style={{
                      background: "#e0f2fe",
                      color: "#075985",
                      borderColor: "#bae6fd",
                      margin: 0,
                    }}
                  >
                    Washing
                  </Tag>
                </div>

                <div className="bin-card-image-wrap">
                  <img src={bin_img} alt="bin" className="bin-card-image" />
                  <div className="bin-card-name">
                    {bin.bin_name || `Bin ${bin.bin_id}`}
                  </div>
                </div>

                <div className="bin-card-footer">
                  <div
                    className={`pcs-badge ${
                      getPcs(bin) > 0 ? "full-badge" : "empty-badge"
                    }`}
                  >
                    {getPcs(bin)} Pcs
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        <div className="dashboard-loading-wrap">
          <Empty description="No washing bins found" />
        </div>
      )}
    </div>
  );
};

export default Dashboard;